import React from 'react'

import { Contract, UserMetadata } from '../../../common/validations'
import {
  DefectNoticeDefectClasses,
  DefectNoticeListItem,
} from '../../../common/validations/defectNotice'
import { ResidentAppError } from '../../../common/error'
import { useAPIGetDefectNoticesSuspense } from '../../api/apiHooks/useAPIGetDefectNotices'
import { useAPIGetUserMetadataSuspense } from '../../api/apiHooks/useAPIGetUserMetadata'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'
import { useAPIGetUserProfileSuspense } from 'api/apiHooks/useAPIGetUserProfile'
import { useAPIGetContractSuspense } from 'api/apiHooks/useAPIGetContract'
import { useAPIGetDefectClassesSuspense } from 'api/apiHooks/useAPIGetDefectClasses'

interface Data {
  contract: Contract
  defectClasses: DefectNoticeDefectClasses
  defectNotices: DefectNoticeListItem[]
  userMetadata: UserMetadata
}

export const DataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()
  const { data: contract } = useAPIGetContractSuspense(currentContractId)
  const { data: defectClasses } = useAPIGetDefectClassesSuspense()
  const { data: user } = useAPIGetUserProfileSuspense()
  const { data: defectNotices } =
    useAPIGetDefectNoticesSuspense(currentContractId)

  const { data: userMetadata } = useAPIGetUserMetadataSuspense()

  // Make sure the user has a phone number
  if (!user.phoneNumber) {
    throw ResidentAppError.ClientError('DEFECT_NOTICE_MISSING_PHONE_NUMBER')
  }

  return children({
    contract,
    defectClasses,
    defectNotices,
    userMetadata,
  })
}
